import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, mergeApplicationConfig, PLATFORM_ID } from '@angular/core';
import { environment } from '@nx-superprep/environment';
import { fetchConfig } from '@nx-superprep/backend/config';
import { log } from '@nx-superprep/utils';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import * as Sentry from '@sentry/angular';

const initializeSentry = (version: string) => {
  if (!environment.production) return;

  Sentry.init({
    dsn: "https://d8e6e4b57f846c11d40ffcfa332b7a00@o4507301716951040.ingest.us.sentry.io/4507301722324992",
    enabled: environment.production,
    release: `popstudy@${version}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    ignoreErrors: [
      'Network request failed',
      'Failed to fetch',
      'NetworkError',
      'withrealtime/messaging'
    ],
    tracesSampleRate: 0.2,
    tracePropagationTargets: ["localhost", /^https:\/\/www\.popstudy\.com\/api/],
    profilesSampleRate: 0.2,
    replaysSessionSampleRate: !environment.config?.isProduction ? 1.0 : 0.05,
    replaysOnErrorSampleRate: 0.5,
  });
};

interface ConfigWithVersion {
  version?: string;
}

const bootstrapApp = (config: unknown) => {
  log.debug(PLATFORM_ID, config);
  environment.config = config;

  // Initialize Sentry with version from API or fallback to environment version
  initializeSentry((config as ConfigWithVersion).version || environment.version);

  if (environment.production) {
    enableProdMode();
    return Sentry.startSpan(
      { name: 'bootstrap-angular-application', op: 'ui.angular.bootstrap' },
      () => bootstrapApplication(
        AppComponent,
        mergeApplicationConfig(appConfig, {
          providers: [{ provide: PLATFORM_ID, useValue: 'browser' }]
        })
      )
    );
  }

  return bootstrapApplication(
    AppComponent,
    mergeApplicationConfig(appConfig, {
      providers: [{ provide: PLATFORM_ID, useValue: 'browser' }]
    })
  );
};

// Start the application
fetchConfig(environment.config)
  .then(bootstrapApp)
  .catch(error => {
    console.error('Application bootstrap failed:', error);
    //document.addEventListener('DOMContentLoaded', () => {
    // Fallback bootstrap without config if needed
    bootstrapApp({ version: environment.version });
    //})
  });

